import instance from "./axios";

export const api_getFilterResult = async (payload, cookies) => {
  console.log("Get Filter Result");
  console.log("cookies: ", cookies);
  try {
    const { data } = await instance.post("ballsStat/getFilterResult", payload, {
      headers: {
        "Content-Type": "application/json",
        // Cookie: cookies,
      },
    });
    // if (data.status !== undefined) throw Error(data.message);
    console.log(data)
    return { status: "success", data };
  } catch (err) {
    console.error("getFilterResult ERROR");
    return { status: "error", message: err.message };
  }
};

export const api_getPlayerRoster = async () => {
  console.log("Get Player Roster");
  try {
    const { data } = await instance.get("/ballsStat/getPlayerRoster");
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getFilterLeagueData = async () => {
  console.log("Get Filter League Data");
  try {
    const { data } = await instance.get("/ballsStat/getFilterLeagueData");
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getUmpireGameMapping = async () => {
  console.log("Get Umpire Game Mapping");
  try {
    const { data } = await instance.get("/ballsStat/getUmpireGameMapping");
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getBallsStatList = async (payload) => {
  console.log("Get BallsStat List");
  try {
    const { data } = await instance.post(
      "/ballsStat/getBallsStatList",
      payload,
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_get2021SinglePlayerStat = async (payload) => {
  console.log("Get 2021 Single Player Stat");
  try {
    const { data } = await instance.post(
      "/ballsStat/get2021SinglePlayerStat",
      payload,
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_get2022SinglePlayerStat = async (payload) => {
  console.log("Get 2022 Single Player Stat");
  try {
    const { data } = await instance.post(
      "/ballsStat/get2022SinglePlayerStat",
      payload,
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getABLFilterResult = async (payload) => {
  console.log("Get ABL Filter Result");
  try {
    const { data } = await instance.post(
      "/ballsStat/abl/getFilterResult",
      payload,
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getSCOUTFilterResult = async (payload) => {
  console.log("Get Scout Filter Result");
  try {
    const { data } = await instance.post(
      "/ballsStat/scout/getFilterResult",
      payload,
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

// Todo: 可能是上傳功能，但還不確定有沒有 response
export const api_uploadPitchingSource = async (payload) => {
  console.log("Upload Pitching Source");
  try {
    const { data } = await instance.post(
      "/ballsStat/uploadPitchingSource",
      payload,
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getScoutPlayerStat = async (payload) => {
  console.log("Get Scout Player Stat");
  try {
    const { data } = await instance.post(
      "/ballsStat/getScoutPlayerStat",
      payload,
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getInitRecord = async (payload) => {
  console.log("Get Init Record");
  try {
    const { data } = await instance.post("/ballsStat/getInitRecord", payload);
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getPlateIDRecord = async (payload) => {
  console.log("Get Plate ID Record");
  try {
    const { data } = await instance.post(
      "/ballsStat/getPlateIDRecord",
      payload,
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getSinglePlayerPersonInfo = async (payload) => {
  console.log("Get Single Player Person Info");
  try {
    const { data } = await instance.post(
      "/ballsStat/getSinglePlayerPersonInfo",
      payload,
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getCatcherEdgePitches = async (payload) => {
  console.log("Get Catcher Edge Pitches");
  try {
    const { data } = await instance.post(
      "/ballsStat/getCatcherEdgePitches",
      payload,
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getDisciplineLeaderboardData = async (payload) => {
  console.log("Get Discipline Leaderboard Data");
  try {
    const { data } = await instance.post(
      "/ballsStat/getDisciplineLeaderboardData",
      payload,
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getGameReportData = async (payload) => {
  console.log("Get Game Report Data");
  try {
    const { data } = await instance.post(
      "/ballsStat/getGameReportData",
      payload,
      {
        headers: {
          Cookie: document.cookie,
        },
      },
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getFilmroomResult = async (payload) => {
  console.log("Get Filmroom Result");
  try {
    const { data } = await instance.post(
      "/ballsStat/getFilmroomResult",
      payload,
    );
    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

export const api_getPlateIDRecordData = async (payload) => {
  console.log("Get Plate ID Record Data");
  try {
    const { data } = await instance.post(
      "/ballsStat/getPlateIDRecordData",
      payload,
    );

    console.log("getPlateIDRecordData: ", data);

    if (data.status !== undefined) throw Error(data.message);
    return { status: "success", data };
  } catch (err) {
    return { status: "error", message: err.message };
  }
};
